var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-table bootstrap"},[_c('v-client-table',{attrs:{"data":_vm.tableData,"columns":_vm.tableColumns,"options":_vm.tableOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }